import Mustache from 'mustache';

class AccessoryAutocomplete {
  constructor() {
    this.accessoryInput = document.getElementById('accessory-search');
    this.accessoryList = document.getElementById('accessory-list');
    this.ajaxStarted = false;
  }

  init() {
    this.accessoryInput.addEventListener('focus', e => {
      if(!this.ajaxStarted) {
        this.getAccessories().then(accessoryData => {
          this.ajaxStarted = true;
          this.renderAccessories(accessoryData);
        });
      }
    });
  }

  async getAccessories() {
    return (await fetch('/stage-ajax/getAutocompleteAccessories')).json();
  }

  renderAccessories(response) {
    const template = `
      {{#.}}
        <option>{{.}}</option>
      {{/.}}
    `
    this.accessoryList.innerHTML = Mustache.render(template, response);
  }
}

export default new AccessoryAutocomplete();
